import {StyleSheet} from 'react-native';

import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {},
  header: {
    paddingVertical: 20,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItem: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
});
